import { useMutation } from '@tanstack/react-query';

import { generateCode, testCode } from './requests';

export const useGenerateCode = () => {
  return useMutation({
    mutationFn: generateCode,
  });
};

export const useTestCode = () => {
  return useMutation({
    mutationFn: testCode,
  });
};
